import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content is-medium box" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Paste or type the content you want to encode here:", -1)
const _hoisted_6 = { class: "control" }
const _hoisted_7 = {
  class: "box result",
  id: "result"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-primary is-light" }, [
  /*#__PURE__*/_createTextVNode(" ⭐ Remember to "),
  /*#__PURE__*/_createElementVNode("b", null, "bookmark"),
  /*#__PURE__*/_createTextVNode(" this page so you can "),
  /*#__PURE__*/_createElementVNode("b", null, "encode URLs"),
  /*#__PURE__*/_createTextVNode(" next time faster ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, " Welcome to our URL encoder website! Here you can easily encode special characters in a string to make it a valid URL without the need to install any software on your computer. URL encoding is the process of converting characters that are not allowed in a URL to their corresponding percentage-encoded form. It is commonly used to encode data that is sent in a URL, such as query strings or form data. Our URL encoder is easy to use, simply paste the string you would like to encode into the input box. The encoded URL will be generated for you to use in your application. Try it out now and see how it can simplify the process of creating valid URLs! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.msg), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "input is-primary",
              type: "text",
              placeholder: "Text to encode",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.urlEncode && _ctx.urlEncode(...args)))
            }, null, 544), [
              [
                _vModelText,
                _ctx.text,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.encodedText), 1)
    ]),
    _hoisted_8,
    _hoisted_9
  ], 64))
}